/**
 * Daytona IPC protocol version. Bumped on breaking shape changes.
 *
 * v1: legacy, two-level messageType/chunkType, no blockId, asymmetric stops.
 *     See `daytona-ipc.types.ts` (deleted at end of v2 rollout window).
 * v2: flat `kind` discriminator, stable blockId minted at source, symmetric
 *     start/delta/stop for every block kind including tool_use.
 */
export const AGENT_IPC_PROTOCOL_VERSION = 2 as const;

export type AgentIpcProtocolVersion = typeof AGENT_IPC_PROTOCOL_VERSION;
